import React from "react";
// Chakra imports
import {
    Flex,
    Box,
    Spacer,
    Button,
    ButtonGroup,
    Icon 
} from "@chakra-ui/react";
// import { ArrowLeftIcon, ArrowRightIcon, Arro } from '@chakra-ui/icons';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight, MdFirstPage, MdLastPage } from 'react-icons/md';


function Pagination({
    totalItems,
    pageRows,
    currentPage,
    onPageChanged,
}) {

    const limitToShrink = 12;
    const shrinkVisibleRange = 3;
    const totalPages = Math.round(totalItems / pageRows);

    const shouldShrink = () => {
        return totalPages >= limitToShrink;
    }

    const onPrevClicked = () => {
        if (currentPage > 1) {
            onPageChanged(currentPage - 1);
        }
    }

    const onNextClicked = () => {
        if (currentPage < totalPages) {
            onPageChanged(currentPage + 1);
        }
    }

    const onFirstClicked = () => {
        if (currentPage != 1) {
            onPageChanged(1);
        }
    }

    const onLastClicked = () => {
        if (currentPage != totalPages) {
            onPageChanged(totalPages);
        }
    }


    return(
        <ButtonGroup variant="outline" spacing="6" mt="12px" overflow="auto">
            <Flex direction="row" w="100%" justifyContent="center" flex>
                { shouldShrink()
                    ?  <Button 
                        mr="4px" 
                        key="pagination-0x"
                        title="first page"
                        onClick={onFirstClicked}
                        ><Icon as={MdFirstPage}/>
                    </Button>
                    : null 
                }
                <Button 
                    mr="4px" 
                    key="pagination-0x"
                    title="previous page"
                    onClick={onPrevClicked}
                    ><Icon as={MdKeyboardArrowLeft}/>
                </Button>
                { shouldShrink() && (currentPage - 1) > shrinkVisibleRange
                    ? <Button 
                        mr="4px"
                        variant={"link"}
                        onClick={null}
                        alignItems={"end"}
                        >
                        ...
                    </Button>
                    : null
                }
                {   Array.from({length: totalPages > 0 ? totalPages : 1}, (item, index) => {
                        if (shouldShrink() && 
                            ((index+1) < (currentPage-shrinkVisibleRange)) ||
                            ((index+1) > (currentPage+shrinkVisibleRange)) ) {
                                return  null;
                        }
                        return <Button 
                            key={`pagination-${index+1}`}
                            mr="4px"
                            colorScheme={index+1 == currentPage ? "teal" : null}
                            variant={index+1 == currentPage ? "solid" : null}
                            onClick={() => onPageChanged(index+1)}
                            >
                            {index+1}
                        </Button>
                    }) 
                }

                { shouldShrink() && (totalPages - currentPage) > shrinkVisibleRange
                    ? <Button 
                        mr="4px"
                        variant={"link"}
                        onClick={null}
                        alignItems={"end"}
                        >   
                        ...
                    </Button>
                    : null
                }
                <Button 
                    mr="4px" 
                    key="pagination-1x"
                    title="next page"
                    onClick={onNextClicked}
                    ><Icon as={MdKeyboardArrowRight}/>
                </Button>
                { shouldShrink() 
                    ?  <Button 
                        mr="4px" 
                        key="pagination-0x"
                        title="last page"
                        onClick={onLastClicked}
                        ><Icon as={MdLastPage}/>
                    </Button>
                    : null 
                }

                
            </Flex>
        </ButtonGroup>
    );
}

export default Pagination;

